import React from 'react'
import ShareMenu from 'root/src/client/web/base/ShareMenu'
import goToSignInHandler from 'root/src/client/logic/project/handlers/goToSignInHandler'
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder'
import FavoriteIcon from '@material-ui/icons/Favorite'
import classNames from 'classnames'

const Icons = ({
	classes, projectDeliveries, projectShareUrl, isAuthenticated,
	auditFavorites, myFavorites,
}) => (
	<div className={classNames(
		classes.icons,
		'layout-row',
		projectDeliveries ? 'layout-align-end-end' : 'layout-align-end',
	)}
	>
		<button
			type="button"
			className={classes.iconButton}
			onClick={isAuthenticated
				? auditFavorites
				: goToSignInHandler
			}
		>
			{
				myFavorites
					? <FavoriteIcon fontSize="inherit" className={classes.favorite} />
					: <FavoriteBorderIcon fontSize="inherit" className={classes.favoriteBorder} />
			}
		</button>
		<ShareMenu
			classes={{ icon: classes.shareIcon, iconContainer: classes.iconButton }}
			url={projectShareUrl}
		/>
	</div>
)

export default Icons
